import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  CustomInput,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';
import NumberFormat from 'react-number-format';

class PersonifyConsent extends Component {
  state = {
    incomeSource: '',
    additionalIncome: false,
    additionalIncomeSource: ''
  }

  onIncomeChange = (event) => {
    this.setState({ incomeSource: event.target.value });
  }

  formatCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })

  renderIncomeSource = (incomeSource) => {
    if (incomeSource === 'retired-benefits') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label htmlFor="incomePeriod3">Income for next 3 years?</Label>
            <Input type="select" name="income-period3" id="incomePeriod3">
              <option>Select One</option>
              <option>Yes</option>
              <option>No</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label htmlFor="incomePeriod4">Approximate income end date?</Label>
            <Input type="date" name="income-period4" id="incomePeriod4" />
          </FormGroup>
        </CardBody>
      )
    }
  }

  onAdditionalIncomeChange = (event) => {
    this.setState({ additionalIncomeSource: event.target.value });
  }

  handleAdditionalIncome = () => {
    this.setState(prevState => ({
      additionalIncome: !prevState.additionalIncome
    }));
  }

  renderAdditionalIncomeSource = (additionalIncomeSource) => {
    if (additionalIncomeSource === 'employment') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label for="companyName">Company Name or Description</Label>
            <Input type="text" name="company-name" id="companyName" />
          </FormGroup>
          <FormGroup>
            <Label for="monthlyIncome">Monthly income after taxes</Label>
            <Input
              type="tel"
              name="monthly-income"
              id="monthlyIncome"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="incomePeriod">How long earning from this source?</Label>
            <Input type="select" name="income-period" id="incomePeriod">
              <option>Select One...</option>
              <option>0 to 3 Months</option>
              <option>3 to 6 Months</option>
              <option>6 to 12 Months</option>
              <option>1 to 2 Years</option>
              <option>2+ Years</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="mainIncomeSource">How often do you get paid?</Label>
            <Input type="select" name="main-income-source" id="mainIncomeSource">
              <option>Select One...</option>
              <option>Every other week</option>
              <option>Once a month</option>
              <option>Twice a month</option>
              <option>Once a week</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </CardBody>
      )
    } else if (additionalIncomeSource === 'self-employment') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label for="companyName2">Company Name or Description</Label>
            <Input type="text" name="company-name2" id="companyName2" />
          </FormGroup>
          <FormGroup>
            <Label for="monthlyIncome2">Monthly income after taxes</Label>
            <Input
              type="tel"
              name="monthly-income2"
              id="monthlyIncome2"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="incomePeriod2">How long earning from this source?</Label>
            <Input type="select" name="income-period2" id="incomePeriod2">
              <option>Select One</option>
              <option>0 to 3 Months</option>
              <option>3 to 6 Months</option>
              <option>6 to 12 Months</option>
              <option>1 to 2 Years</option>
              <option>2+ Years</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="mainIncomeSource">How often do you get paid?</Label>
            <Input type="select" name="main-income-source" id="mainIncomeSource">
              <option>Select One...</option>
              <option>Every other week</option>
              <option>Once a month</option>
              <option>Twice a month</option>
              <option>Once a week</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </CardBody>
      )
    } else if (additionalIncomeSource === 'retired-benefits') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label for="companyName3">Description</Label>
            <Input type="text" name="company-name3" id="companyName3" />
          </FormGroup>
          <FormGroup>
            <Label for="monthlyIncome3">Monthly income after taxes</Label>
            <Input
              type="tel"
              name="monthly-income3"
              id="monthlyIncome3"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="incomePeriod3">Income for next 3 years?</Label>
            <Input type="select" name="income-period3" id="incomePeriod3">
              <option>Select One</option>
              <option>Yes</option>
              <option>No</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="incomePeriod4">Approximate income end date?</Label>
            <Input type="date" name="income-period4" id="incomePeriod4" />
          </FormGroup>
          <FormGroup>
            <Label for="mainIncomeSource">How often do you get paid?</Label>
            <Input type="select" name="main-income-source" id="mainIncomeSource">
              <option>Select One...</option>
              <option>Every other week</option>
              <option>Once a month</option>
              <option>Twice a month</option>
              <option>Once a week</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </CardBody>
      )
    } else if (additionalIncomeSource === 'other') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label for="companyName3">Description</Label>
            <Input type="text" name="company-name3" id="companyName3" />
          </FormGroup>
          <FormGroup>
            <Label for="monthlyIncome3">Monthly income after taxes</Label>
            <Input
              type="tel"
              name="monthly-income3"
              id="monthlyIncome3"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="mainIncomeSource">How often do you get paid?</Label>
            <Input type="select" name="main-income-source" id="mainIncomeSource">
              <option>Select One...</option>
              <option>Every other week</option>
              <option>Once a month</option>
              <option>Twice a month</option>
              <option>Once a week</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </CardBody>
      )
    }
  }

  render() {
    const { incomeSource, additionalIncome, additionalIncomeSource } = this.state;

    return (
      <div className="page-personify">
        <Container className="consent-form">
          <Row className="justify-content-center">
            <Col xs={12} md={11} lg={7}>
              <Row>
                <Col className="text-center mb-4 mt-2">
                  <h2>Just a few more questions and<br /> then your loan offers!</h2>
                </Col>
              </Row>
              <Card>
                <CardBody>
                  <Row>
                    <Col xs="auto">
                      <CustomInput type="checkbox" id="Consent1" />
                    </Col>
                    <Col className="pl-0">
                      <label htmlFor="Consent1" className="mb-3">I am not an active member of the military, a spouse, or a dependent of one, as defined by the <a href="/">Military Lending Act</a>.</label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="auto">
                      <CustomInput type="checkbox" id="Consent2" />
                    </Col>
                    <Col className="pl-0">
                      <label htmlFor="Consent2" className="mb-3">You have not filed, or considering filing, bankruptcy in the prior 90 days nor do you have any present intention or financial circumstance that would cause you to file bankruptcy at the present time or within the next 45 days.</label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="auto">
                      <CustomInput type="checkbox" id="Consent3" />
                    </Col>
                    <Col className="pl-0">
                      <label htmlFor="Consent3" className="mb-3">Personify Financial may use electronic signatures, communications, records, and may contact me in accordance with the <a href="/">electronic communication policy</a>.</label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="auto">
                      <CustomInput type="checkbox" id="Consent4" />
                    </Col>
                    <Col className="pl-0">
                      <label htmlFor="Consent4" className="mb-3">Personify Financial may obtain and use my credit report in the connection with or as a result of extensions or credit related to my loan application, and for other legitimate purposes related to any loan made, in accordance with the <a href="/">credit report and verification policy</a>.</label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="auto">
                      <CustomInput type="checkbox" id="Consent5" />
                    </Col>
                    <Col className="pl-0">
                      <label htmlFor="Consent5" className="mb-3">I have received delivery of and reviewed the <a href="/">privacy policy</a>.</label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="auto">
                      <CustomInput type="checkbox" id="Consent6" />
                    </Col>
                    <Col className="pl-0">
                      <label htmlFor="Consent6" className="mb-0">By providing your number(s) to us, you are expressly consenting to receiving communications, including, but not limited to, prerecorded or artificial voice message calls, text messages, and calls made by an automatic telephone dialing system, from your lender, or any of its affiliates, service providers, assignees, or agents, at the phone number(s) you provided for servicing and collection purposes related to any loan that you may obtain from the lender.</label>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card>
                <CardHeader className="has-tooltip">
                  <h4 className="mb-0">What is your main source of income?</h4>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label htmlFor="mainIncomeSource">Main Source of Income</Label>
                    <Input type="select" name="main-income-source" id="mainIncomeSource" value={incomeSource} onChange={this.onIncomeChange}>
                      <option value="">Select One...</option>
                      <option value="employment">Employment</option>
                      <option value="self-employment">Self-Employment</option>
                      <option value="retired-benefits">Retired/Benefits</option>
                      <option value="other">Other</option>
                    </Input>
                  </FormGroup>
                  <small className="text-center">Note: Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying the loan.</small>
                </CardBody>
                <Collapse isOpen>
                  {this.renderIncomeSource(incomeSource)}
                </Collapse>
              </Card>

              { additionalIncome &&
                <Card>
                  <CardHeader className="has-tooltip">
                    <h4 className="mb-0">Additional Income</h4>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label htmlFor="additionalIncomeSource">Additional Income Source</Label>
                      <Input type="select" name="additional-income-source" id="additionalIncomeSource" value={additionalIncomeSource} onChange={this.onAdditionalIncomeChange}>
                        <option value="">Select One...</option>
                        <option value="employment">Employment</option>
                        <option value="self-employment">Self-Employment</option>
                        <option value="retired-benefits">Retired/Benefits</option>
                        <option value="other">Other</option>
                      </Input>
                    </FormGroup>
                    <small className="text-center">Note: Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying the loan.</small>
                  </CardBody>
                  <Collapse isOpen>
                    {this.renderAdditionalIncomeSource(additionalIncomeSource)}
                  </Collapse>
                </Card>
              }

              <Row>
                <Col className="ml-auto mr-auto mb-4">
                  <Button onClick={this.handleAdditionalIncome} className="w-100">
                    { additionalIncome ? 'Remove' : 'Add' } additional income
                  </Button>
                </Col>
              </Row>

              { incomeSource !== '' &&
                <Row>
                  <Col className="text-center">
                    <Button tag={Link} to="/personify/approved" color="personify" size="lg" className="w-100 mb-3">Continue</Button>
                    <p>Seeing your offers won't hurt your FICO® Score</p>
                  </Col>
                </Row>
              }

            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default PersonifyConsent;
